// extracted by mini-css-extract-plugin
export default {"buttonQR":"UserQR_buttonQR__uHLQ6"};